import { createSlice } from '@reduxjs/toolkit';
import patchCancelDispute from './patchCancelDispute';
export var initialState = {
    isCanceled: false,
    cancelDisputeError: null
};
var cancelDisputeSlice = createSlice({
    name: 'cancelDispute',
    initialState: initialState,
    reducers: {
        clearCancelDisputeState: function () {
            return initialState;
        }
    },
    extraReducers: function (builder) {
        builder.addCase(patchCancelDispute.fulfilled, function (state) {
            state.isCanceled = true;
        });
        builder.addCase(patchCancelDispute.rejected, function (state, action) {
            var payload = action.payload;
            state.cancelDisputeError = payload;
        });
    }
});
export var clearCancelDisputeState = cancelDisputeSlice.actions.clearCancelDisputeState;
export default cancelDisputeSlice.reducer;
//# sourceMappingURL=cancelDispute.slice.js.map